

























































































































































import { Component as VueComponent } from 'vue';
import { Component, Mixins, Prop, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Counter } from '@/modules/backend/Entities/Counter';
import { EditCounterData } from '@/modules/backend/Dto/EditCounterData';
import EditDialogWrapper from '@/layouts/EditDialogWrapper.vue';
import Mixin from '@/mixins/base';
import { ValidationObserver } from '@/plugins/vee-validate';

const CountersModule = namespace('dashboard/counters');

type VDialog = VueComponent & {
  save: (value: string | Date) => void;
};

@Component({
  mixins: [Mixin],
  components: {
    'edit-dialog-wrapper': EditDialogWrapper
  }
})
export default class CounterEditDialog extends Mixins(Mixin) {
  @CountersModule.Action('Edit')
  private readonly editCounter!: (payload: EditCounterData) => Promise<void>;

  @Ref('observer')
  private readonly observer!: ValidationObserver;

  private readonly pickers = {
    next: false,
    last: false
  };

  @Prop({ required: true }) private readonly counter!: Counter;

  @Ref() readonly dateFromPicker!: VDialog;

  @Ref() readonly dateToPicker!: VDialog;

  private readonly form: EditCounterData = new EditCounterData({
    counterId: this.counter.getId(),
    initialValue: this.counter.getInitialValue(),
    value: this.counter.getValue(),
    serialNumber: {
      device: this.counter.getSerialNumber().getDevice(),
      counter: this.counter.getSerialNumber().getCounter()
    },
    channel: this.counter.getChannel(),
    reconfigure: false,
    note: this.counter.getNote(),
    stamp: this.counter.getStamp(),
    checkInterval: {
      next: this.getCounterCheckIntervalNext(),
      last: this.getCounterCheckIntervalLast()
    }
  });

  private async edit(): Promise<void> {
    /**
     * TODO: NOTE, NOTICE
     * In this moment this.form.initialValue is 'string' what`s wrong and form is not valid.
     * Should be replace or type cast with Number
     */

    this.observer.reset();

    if (await this.observer.validate()) {
      this.form.modify('initialValue', (value: string) => Number(value));
      this.form.modify('value', (value: string) => Number(value));
      await this.editCounter(this.form);
    } else {
      throw new Error('Validation error');
    }
  }

  private getCounterCheckIntervalLast(): string {
    /* eslint-disable @typescript-eslint/no-magic-numbers */
    const last = this.counter.getCheckInterval().getLast()?.toISOString().substr(0, 10);

    if (last) {
      return last;
    }

    return '—';
  }

  private getCounterCheckIntervalNext(): string {
    /* eslint-disable @typescript-eslint/no-magic-numbers */
    const next = this.counter.getCheckInterval().getNext()?.toISOString().substr(0, 10);

    if (next) {
      return next;
    }

    return '—';
  }

  private clearForm(): void {
    this.form.counterId = this.counter.getId();
    this.form.initialValue = this.counter.getInitialValue();
    this.form.value = this.counter.getValue();
    if (this.form.serialNumber) {
      this.form.serialNumber.device = this.counter.getSerialNumber().getDevice();
      this.form.serialNumber.counter = this.counter.getSerialNumber().getCounter();
    }
    this.form.channel = this.counter.getChannel();
    this.form.reconfigure = false;
    this.form.note = this.counter.getNote();
    this.form.stamp = this.counter.getStamp();
    if (this.form.checkInterval) {
      this.form.checkInterval.last = this.getCounterCheckIntervalLast();
      this.form.checkInterval.next = this.getCounterCheckIntervalNext();
    }

    this.observer.reset();
  }

  private async dialogOpenHandler(): Promise<void> {
    this.observer.reset();
    this.clearForm();
  }
}
